import React from 'react';

const Message = () => {
    return (
        <div className='container mx-auto bg-secondary px-4 md:px-8 py-6 md:py-12 rounded-2xl flex flex-col lg:flex-row items-center lg:items-start lg:gap-8 w-full max-w-6xl'>
            {/* Image Section */}
            <div className='flex-shrink-0 w-44 lg:w-56'>
                <img 
                    className='w-full rounded-2xl border-4 border-primary' 
                    src="https://i.ibb.co/sJyXH92j/PR.jpg" 
                    alt="principal" 
                />
            </div>

            {/* Text Section */}
            <div className='text-white text-left md:text-justify flex-1 max-w-3xl'>
                <p className="text-lg leading-relaxed">
                    The major challenge for today’s engineering educational institutions is to accommodate the ever-varying aspirations of the younger generation because of increasingly changing demand and development in industries. We constantly put efforts to accommodate these aspirations by fine-tuning the academics of college with innovative and practical-oriented teaching-learning practices along with other developmental activities. Our approach reflects the educational needs of the 21st century.
                </p>
                <br/>
                <p className='text-primary font-bold text-xl'>Prof. Md Maruful Haque</p>
                <p className="text-lg">Principal, Imperial College of Engineering</p>
                
                {/* Centered Button */}
                <div className="flex justify-center mt-4">
                    <button className="btn btn-primary px-6 py-2 rounded-full">Read More</button>
                </div>
            </div>
        </div>
    );
};

export default Message;
